module.exports = __webpack_public_path__ + "static/media/padelappen-case.b23d1eed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/padelappen-case.jpg
// module id = 512
// module chunks = 0